export const environment = {
    production: false,
    API_ENDPOINT: 'https://api.dev.api-arrayan.cl/',
    lemu_base: 'https://dev.api-arrayan.cl/',
    WS_URL: 'wss://luq81qnp8d.execute-api.us-east-2.amazonaws.com/dev',

    //variables POSTHOG
    POSTHOG_KEY:'phc_rlm8E1kIyQwGO0WblnBvQVsKKJCzaLTMnzeUdIC8jM9',
    POSTHOG_HOST:'https://posthog.simplilab.tech'
}

